import { Privacy, PrivacySelector } from "PFApp/components/activity_form/form_selectors/privacy_selector";
import {
  FIELD_AUDIENCES_KEY,
  FIELD_PRIVACY_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { getPrivacyConfiguration } from "PFApp/helpers/activity_form/get_privacy_configuration";
import { useCallback } from "react";
import { useController, useFormContext } from "react-hook-form";

import { ConfirmationModals } from "../../../activity_form.types";
import { useActivityFormStore, useActivityFormStoreActions } from "../../../activity_form_store";
import { FormSection, SectionProps } from "../../form_section";

export const PrivacyFormSection = ({ id, title }: SectionProps) => {
  const { control, setValue } = useFormContext();

  const { isEdit, isDraft, isNew } = useActivityFormStore((state) => state.activityStatus);
  const modals = useActivityFormStore((state) => state.modals);
  const activity = useActivityFormStore((state) => state.activity);
  const template = useActivityFormStore((state) => state.template);
  const parentActivity = useActivityFormStore((state) => state.parentActivity);

  const { isForcePrivate } = getPrivacyConfiguration({ template, parentActivity });
  const { setModalDisplayed } = useActivityFormStoreActions();

  const { field: audiencesField } = useController({ control, name: FIELD_AUDIENCES_KEY });
  const { field: privacyField } = useController({ control, name: FIELD_PRIVACY_KEY });

  const isDisabled = isEdit && !isDraft && isForcePrivate;

  const handlePrivateChange = useCallback(
    (id: Privacy) => {
      if (!!activity.private && !modals[ConfirmationModals.Public].isConfirmed) {
        setModalDisplayed(ConfirmationModals.Public, true);
      } else {
        if (id === Privacy.Private) {
          setValue(FIELD_AUDIENCES_KEY, activity.audiences || [], { shouldDirty: true });
        } else {
          setValue(FIELD_AUDIENCES_KEY, [], { shouldDirty: true });
        }
        setValue(FIELD_PRIVACY_KEY, id === Privacy.Private, { shouldDirty: true });
      }
    },
    [modals, setValue, setModalDisplayed, activity.private, activity.audiences]
  );

  return (
    <FormSection id={id} title={title} qaId="make-private-section">
      <PrivacySelector
        isDisabled={isDisabled}
        isPrivate={privacyField.value}
        isNew={isNew}
        audience={audiencesField.value}
        onPrivateChange={handlePrivateChange}
        onAudiencesChange={audiencesField.onChange}
      />
    </FormSection>
  );
};
